<script>
import ListHistoryAsesmen from "./list-history-asesmen.vue";

export default {
  components: {
    ListHistoryAsesmen,
  },
};
</script>
<template>
  <b-tabs nav-class="mym-inner-tabs">
    <b-tab title="Asesmen KKJ" active>
      <ListHistoryAsesmen tipeAsesmen="kkj" />
    </b-tab>
    <b-tab title="Pembinaan Grade">
      <ListHistoryAsesmen tipeAsesmen="pembinaan_grade" />
    </b-tab>
  </b-tabs>
</template>